import { type TrialOffer } from '@/api/gen/_model/trialOffer';

/** 서버가 최종 판정한 국내 휴대폰 인증 무료체험 제안인지 확인한다. */
export const isPhoneTrialUpsellEligible = (trialOffer?: TrialOffer) =>
  trialOffer?.type === 'PHONE_VERIFICATION';
